import React, { useCallback, useMemo, useState } from 'react'
import useFetchData from '../../../../../hooks/useFetchData'
import DataGrid from '../../../../table/DataGrid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@mui/material/Typography'
import MenuIconButton from '../../../../button/MenuIconButton'
import { replaceDash, humanize } from '../../../../../utils/text'
import { useSelector } from 'react-redux'
import Loading from '../../../../Loading/Loading'
import useRoles from '../../../../../hooks/roles/useRoles'
import groupByRows from 'lodash/groupBy'
import { sortData, sortDataByTwoColumns } from '../../../../../utils'

const List = ({ onModal }) => {
  const permissions = useSelector((state) => state?.session?.permissions?.role || {})
  const list = useSelector((state) => state?.roles?.list || [])
  const [role, setRole] = useState({})

  const { isLoadingList } = useRoles()
  const { isLoading: isLoadingModule, data: dataModule } = useFetchData('roles/modules')

  const onModalCB = useCallback(
    (type) => {
      onModal(type, role)
    },
    [onModal, role]
  )

  const columns = useMemo(() => {
    const itemsOptions = [
      {
        label: 'Edit',
        icon: 'pencil',
        permissions: permissions['updated-custom-role'],
        onClick: () => onModalCB('edit')
      },
      {
        label: 'Delete',
        icon: ['fas', 'trash-alt'],
        permissions: permissions['deleted-custom-role'],
        onClick: () => onModalCB('delete')
      }
    ]

    let columns =
      sortData(list, 'name', 'acs')?.map((role) => ({
        key: role._id,
        align: 'center',
        className: 'p-0  w-auto border-x border-muted',
        show: true,
        label: (
          <div
            className={`text-center relative flex items-center ${role.isCustom ? 'justify-between' : 'justify-center'} gap-2`}
          >
            <Typography
              variant='inherit'
              className={`text-xs text-center ${role.isCustom ? 'pl-4' : 'px-4'}`}
            >
              {role.name}
            </Typography>
            {role.isCustom && (
              <div className='pr-4'>
                <MenuIconButton
                  id={`menu-role-${role._id}`}
                  title='Config role'
                  icon={['far', 'ellipsis-vertical']}
                  items={itemsOptions}
                  onClick={() => setRole(role)}
                />
              </div>
            )}
          </div>
        )
      })) || []
    columns.unshift({
      label: 'Roles and permissions',
      key: 'moduleAction',
      className: 'bg-white min-w-200px sticky left-0 border-r border-muted z-1',
      show: true
    })

    return columns
  }, [list, role])

  const rows = useMemo(() => {
    let rows = []
    dataModule?.forEach((module) => {
      module?.actions?.forEach((action) => {
        rows.push({
          _id: `${module.moduleName}-${action._id}`,
          moduleName: humanize(module.moduleName),
          action: action._id,
          hide: false,
          moduleAction: (
            <div className='flex items-center gap-2'>
              <Typography variant='inherit' className='capitalize px-2'>
                {replaceDash(action._id)}
              </Typography>
            </div>
          ),
          ...action?.roles?.reduce((acc, role) => {
            acc[role._id] = (
              <div className='py-1'>
                <FontAwesomeIcon icon={['fal', 'check']} />
              </div>
            )
            return acc
          }, {})
        })
      })
    })

    return sortDataByTwoColumns(rows, 'moduleName', 'action')
  }, [dataModule])

  if (isLoadingList) return <Loading />

  return (
    <DataGrid
      id='roles-and-permissions'
      rows={rows}
      rowsPerPage={isLoadingModule ? 10 : rows.length}
      showSetting={false}
      columns={columns}
      loading={isLoadingModule}
      groupBy='moduleName'
    />
  )
}

export default List
